import React from 'react';
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import NumberInput from 'screens/components/basic/NumberInput';

const componentName = "YearlySalesReport";

const Header = ({showBody, download}) => (
    <div className="searchBarContainer">
        <div className="row m-0">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 m-0">
                <NumberInput
                    name={componentName + LOOKUP.report.annualSales.year.name}
                    fullWidth={true}
                    hintText={LOOKUP.report.annualSales.year.label}
                    label={LOOKUP.report.annualSales.year.label}
                    floatingLabelText={LOOKUP.report.annualSales.year.label}
                    maxLength={4}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-1"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={download}
                />
            </div>
        </div>
    </div>
);

export default Header;
